export const GET_FOLLOWUPS = "GET_FOLLOWUPS";
export const UPDATE_FOLLOWUP = "UPDATE_FOLLOWUP";

export const getFollowUps = (payload) => ({
  type: GET_FOLLOWUPS,
  followUps: payload.rows,
  totalCount: payload.count,
});

export const updateFollowUp = (followUp) => ({
  type: UPDATE_FOLLOWUP,
  followUp,
});
